import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import Form, { Field } from 'rc-field-form';
import { toast } from 'react-toastify';
import { RootState } from '@/models';
import { postSendValidCode, postConsult } from '@/services/product';
import Checkbox from '@/components/checkbox';
import { isMobilePhone } from '@/constants/regexp';
import LabelField from '@/business-components/normal-label-field';
import CountDown from '@/components/count-down';
import styles from './index.module.scss';

interface InstitutionSettledProps {
  id?: string;
  boxProduct: { productName: string; boxProductId: string };
  onSubmitSusccess?: () => void;
}
const emailReg =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// export const getServerSideProps = async ({ res }) => {
//   res.setHeader('Cache-Control', 'public, s-maxage=59, stale-while-revalidate=119');
//   return {};
// };

const InstitutionSettled: React.FC<InstitutionSettledProps> = ({ boxProduct, onSubmitSusccess }) => {
  console.log(onSubmitSusccess);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state: RootState) => state.user);
  const initialValues = {
    contactPhone: userInfo?.phone,
  };
  const sendCodeHandle = useCallback(async value => {
    try {
      await postSendValidCode(value);
    } catch (error) {}
  }, []);
  const submit = useCallback(async () => {
    try {
      const values = await form.validateFields();
      const res: any = await postConsult({ ...boxProduct, ...values, boxProductName: boxProduct.productName });
      if (res.code !== 200) throw new Error();
      toast.success('询价信息发送成功');
      onSubmitSusccess && onSubmitSusccess();
      //   await dispatch({ type: 'user/patchUserInfo', payload: values });
      dispatch({ type: 'modal/close' });
      //   toast.success('提交成功');
    } catch (e) {
      console.log(e);
    }
  }, [boxProduct, dispatch, form, onSubmitSusccess]);
  return (
    <div className={styles.registContent}>
      <div className={styles.registContentTitle}>咨询{boxProduct?.productName}的报价</div>
      <div className={styles.registContentSubTitle}>请填写您的信息，完成后为您提供产品报价与机构联系方式</div>
      <Form form={form} preserve={false} initialValues={initialValues}>
        <div className={styles.labelField}>
          <LabelField
            name="companyName"
            label="企业名称"
            required
            rules={[
              { required: true, message: '请输入您的企业名称' },
              {
                async validator(_, value) {
                  if (
                    /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu.test(value) ||
                    /^(\s+(.*)\s*)|(\s*(.*)\s+)$/.test(value)
                  ) {
                    return Promise.reject('请输入正确的企业名称');
                  } else if (
                    (/^(.*)\p{Unified_Ideograph}+(.*)$/u.test(value) && value.length >= 2) ||
                    (/^([A-Za-z0-9]*)|([A-Za-z0-9]+(\s)*[A-Za-z0-9])$/.test(value) && value.length >= 4)
                  ) {
                    return Promise.resolve();
                  } else if (
                    (/^(.*)\p{Unified_Ideograph}+(.*)$/u.test(value) && value.length < 2) ||
                    (/^([A-Za-z0-9]+((\w|\s)*)[A-Za-z0-9]+)|[A-Za-z0-9]+$/.test(value) && value.length < 4)
                  ) {
                    return Promise.reject('请输入完整的企业名称');
                  }
                  return Promise.reject('请输入正确的企业名称');
                },
              },
            ]}
          >
            <input className={styles.fieldInput} placeholder="请输入您的企业名称" />
          </LabelField>
        </div>
        <div className={styles.labelField}>
          <LabelField
            name="companyEmail"
            label="企业邮箱"
            required
            rules={[
              { required: true, message: '请输入您的企业邮箱' },
              { pattern: emailReg, message: '请输入正确的企业邮箱' },
            ]}
          >
            <input className={styles.fieldInput} placeholder="请输入您的企业邮箱" />
          </LabelField>
        </div>
        <div className={styles.labelField}>
          <LabelField name="contactName" label="姓名" required rules={[{ required: true, message: '请输入您的姓名' }]}>
            <input className={styles.fieldInput} placeholder="请输入您的姓名" />
          </LabelField>
        </div>
        <div className={styles.labelField}>
          <LabelField name="contactJob" label="职务" required rules={[{ required: true, message: '请输入您的职务' }]}>
            <input className={styles.fieldInput} placeholder="请输入您的职务" />
          </LabelField>
        </div>
        <div className={styles.labelField}>
          <Field shouldUpdate>
            {(_, __, { getFieldValue }) => {
              return (
                <div className={styles.phoneField}>
                  <LabelField
                    name="contactPhone"
                    label="手机号"
                    required
                    rules={[{ pattern: isMobilePhone, message: '请输入您的手机号' }]}
                  >
                    <input className={styles.fieldInput} placeholder="请输入您的手机号" />
                  </LabelField>
                  <div className={styles.countDown}>
                    <CountDown
                      theme="block"
                      canSend={getFieldValue('contactPhone') && isMobilePhone.test(getFieldValue('contactPhone'))}
                      onSend={() => {
                        sendCodeHandle({ phoneNum: getFieldValue('contactPhone') });
                      }}
                    />
                  </div>
                </div>
              );
            }}
          </Field>
        </div>
        <div className={styles.labelField}>
          <LabelField name="validCode" label="验证码" required rules={[{ required: true, message: '请输入验证码' }]}>
            <input className={styles.fieldInput} placeholder="请输入验证码" />
          </LabelField>
        </div>
        <Field shouldUpdate>
          {(_, __, { getFieldValue, getFieldsError, isFieldsTouched }) => {
            const isAllTouched =
              (initialValues.contactPhone || isFieldsTouched(['contactPhone'], true)) &&
              isFieldsTouched(['validCode'], true) &&
              getFieldValue('select') === true;

            const hasErrors = !!getFieldsError().filter(({ errors }) => errors.length).length;
            return (
              <button className={styles.submitBtn} type="submit" disabled={!isAllTouched || hasErrors} onClick={submit}>
                提交
              </button>
            );
          }}
        </Field>
        <>
          <div className={classNames('flex-row-nowrap', 'flex-center-center', styles.userProtocol)}>
            <Field name="select">
              <Checkbox />
            </Field>
            <div className={styles.protocolText}>我已阅读并同意</div>
            &nbsp;
            <a href="/protocol/cooperation" target="_blank" className={styles.protocolLink}>
              平台合作协议
            </a>
          </div>
        </>
      </Form>
    </div>
  );
};

export default InstitutionSettled;
